<section class="default">
  <router-outlet />
</section>
